import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CompleteProfile from 'pages/kunde/profiles/complateProfile'
import EmployPage from 'pages/employ/page';
import CustomerPage from 'pages/kunde/page';
import KidProfile from 'pages/kunde/profiles/NewKidProdile';
import StatisticPage from 'pages/statistic/page';
import LandingPage from 'pages/landingpage/page';
import EmploySetPassword from 'pages/employ/profile/employSetPassword';
import UpdatePassword from 'pages/landingpage/profile/resetPassword';
import NotFoundPage from 'pages/notFound404/page';


export default function AppRouter() {
    return (
        <Router>
            <Routes>
                <Route path="/reservierungsportal" index element={<LandingPage />} />
                <Route path="/reservierungsportal/EmployHomePage" element={<EmployPage />} />
                <Route path="/reservierungsportal/EmploySetPassword" element={<EmploySetPassword />} />
                <Route path="/reservierungsportal/CustomerHomePage" element={<CustomerPage />} />
                <Route path="/reservierungsportal/compliatProfile" element={<CompleteProfile />} />
                <Route path="/reservierungsportal/NewkidsProfile" element={<KidProfile />} />
                <Route path="/reservierungsportal/StatisticPage" element={<StatisticPage />} />
                <Route path="/reservierungsportal/resetPassword" element={<UpdatePassword />} />
                <Route path="*" element={<NotFoundPage />} />

            </Routes>
        </Router>
    );
};
